module.exports = __webpack_public_path__ + "static/power-img2-1-2ca45c7f9262819a2661d2c9b25b8298.png";